const script = document.getElementById("button-state");
const param = script.getAttribute("data-param");

document.querySelectorAll(`.${param}`).forEach((quantityContainer) => {
  const minusButton = quantityContainer.querySelector("button[name='minus']");
  const plusButton = quantityContainer.querySelector("button[name='plus']");
  const quantityInput = quantityContainer.querySelector(".quantity__input");

  function updateButtonState() {
    const minValue = parseInt(quantityInput.min, 10) || 1;
    const maxValue = parseInt(quantityInput.max, 10) || Infinity;
    let currentValue = parseInt(quantityInput.value, 10);

    minusButton.disabled = currentValue <= minValue;
    plusButton.disabled = currentValue >= maxValue;
  }

  quantityInput.onchange = function() {
    updateButtonState();
  }

  // Initialize button state on load
  updateButtonState();
});
